import React from "react";

interface BackProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;
}
const IconBack: React.FC<BackProps> = ({ className, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height} viewBox="0 0 21 20" fill="none" ><mask id="a" maskUnits="userSpaceOnUse" x="0" y="0" width="21" height="20"><path fill="#D9D9D9" d="M.85 0h20v20h-20z" /></mask><g mask="url(#a)"><path d="m8.767 10.005 6.125 6.125a.96.96 0 0 1 .302.73q-.01.416-.323.729a1 1 0 0 1-.73.312 1 1 0 0 1-.728-.312l-6.417-6.396a1.7 1.7 0 0 1-.375-.563 1.7 1.7 0 0 1-.125-.625q0-.312.125-.625.125-.312.375-.562L13.413 2.4a.98.98 0 0 1 .74-.302q.426.01.739.323a1 1 0 0 1 .312.73 1 1 0 0 1-.312.728z" fill="#000" /></g></svg>
);
export default IconBack;
